// QR کارت مراجعه‌کننده (AP-PAT-02، US-PAT-005): رسم SVG از کد امضاشده سرور با qrcode-generator (C-AGENT-466)؛ بدون innerHTML.
import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

export interface QrCodeProps {
  value: string;
  /** اندازه نمایشی (px). */
  size?: number;
  title: string;
}

export function QrCode({ value, size = 160, title }: QrCodeProps) {
  const { path, count } = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(value);
    qr.make();
    const modules = qr.getModuleCount();
    let d = '';
    for (let row = 0; row < modules; row++) {
      for (let col = 0; col < modules; col++) {
        if (qr.isDark(row, col)) {
          d += `M${col + 4},${row + 4}h1v1h-1z`;
        }
      }
    }
    return { path: d, count: modules + 8 };
  }, [value]);
  return (
    <svg
      role="img"
      aria-label={title}
      viewBox={`0 0 ${count} ${count}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      data-testid="patient-card-qr"
    >
      <rect width={count} height={count} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
